import { Button, Typography } from "@mui/material"
import ThankyouImg from '../../components/images/Thankyou2.jpeg';
const ThankYou=(props:any)=>{

     return <div className="thankyouBg">
        {/* <img src={ThankyouImg}/> */}
        <Typography variant="h3" color="#000">Thank You!</Typography>
        <Typography variant="subtitle1" color="Gray">We have received your request and will be in touch with you soon.</Typography>
        <Typography variant="subtitle1" color="Gray">Your service request <b>Reference Number is {props.referenceNumber}</b></Typography>  
    </div>
}
export default ThankYou;